import loadOpenTok from '@/utils/opentok.loader'

const MESSAGE_TYPES = {
  OPENTOK: 'opentok',
}

const ACTIONS = {
  START_CALLING: 'call-audience',
  STOP_CALLING: 'stop-call',
}

function handleStartCalling(doc, rootComponent) {
  if (rootComponent.audienceId === doc.data.audienceUnique) {
    rootComponent.$store.state.presentation.token = doc.data.token
    rootComponent.$store.state.presentation.expiredToken = doc.data.expiredToken
    rootComponent.$store.state.presentation.session = doc.data.session
    rootComponent.$store.state.voiceCall = {
      isOpen: true,
      status: 'waiting-accept',
    }
    loadOpenTok().catch(() => {})
  }
}

function handleStopCalling(doc, rootComponent) {
  rootComponent.$store.state.voiceCall = {
    isOpen: false,
  }
}

const actionHandlers = {
  [ACTIONS.START_CALLING]: handleStartCalling,
  [ACTIONS.STOP_CALLING]: handleStopCalling,
}

function handleOpenTokMessage(doc, rootComponent) {
  const actionHandler = actionHandlers[doc.action]
  if (actionHandler && typeof actionHandler === 'function') {
    actionHandler(doc, rootComponent)
  }
}

const OpenTokWebSocketSubscriber = {
  [MESSAGE_TYPES.OPENTOK]: handleOpenTokMessage,
}

export default OpenTokWebSocketSubscriber
